var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"d-inline-flex justify-start align-center",style:({'margin-right': `-${_vm.size*1.6}px`})},[_c('JerseySvg',{staticClass:"svg",style:(_vm.SvgStyle),attrs:{"color":_vm.jerseyColor,"collarColor":_vm.collarColor}}),_c('div',{staticClass:"pt-1",style:(_vm.NumberStyle)},[_vm._v(_vm._s(_vm.number))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }